import React from 'react';

export function SuccessIcon() {
  return (
    <svg width="101" height="100" viewBox="0 0 101 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50.5015" cy="50" r="45" stroke="#0A0A0A" strokeWidth="2" />
      <circle
        cx="50.5023"
        cy="50.0001"
        r="38.6786"
        fill="url(#paint0_linear_5_29683)"
        fillOpacity="0.6"
        stroke="#0A0A0A"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
        strokeDasharray="1 1"
      />
      <path
        d="M34.2495 51.1538L45.7839 63.9304C46.2936 64.495 47.1851 64.4773 47.672 63.893L71.7495 35"
        stroke="#0A0A0A"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5_29683"
          x1="83"
          y1="15.6251"
          x2="75.9197"
          y2="78.5418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65FEA7" stopOpacity="0" />
          <stop offset="1" stopColor="#3DD57F" />
        </linearGradient>
      </defs>
    </svg>
  );
}
